import { AbstractPmsApiService } from "./abstract.service";
import { NotificationRecipient } from "../models";

/**
 * @class NotificationRecipientPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<NotificationRecipient>}
 */
export class NotificationRecipientPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/notification-recipient(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {NotificationRecipient}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new NotificationRecipient(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<NotificationRecipient>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {NotificationRecipient} notificationRecipient
     * @param {Property} property
     * @returns {Promise.<NotificationRecipient>}
     */
    create(notificationRecipient, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, notificationRecipient.toObjectExcept('property', 'user'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {NotificationRecipient} notificationRecipient
     * @returns {Promise.<boolean>}
     */
    delete(notificationRecipient, property) {
        
        const url = this.url({
            propertyId: property.id,
            id:         notificationRecipient.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {array} ids
     * @param {Property} property
     * @returns {Promise.<boolean>}
     */
    bulkCreate(users, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url + '/bulk-store', {'users': users}, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/notification-recipient.service.js